import { ModalIOF } from '@old/ui/modal/modal';
import { configButtonStylesContained } from '@old/styles/generic-styles';
import i18n from '../../../../libs/language';
import { Button } from '@mui/material';

type WarningModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleSave: () => void;
};

export const WarningModal = ({ open, setOpen, handleSave }: WarningModalProps) => {
  return (
    <ModalIOF open={open} ModalIsOpen={setOpen}>
      <ModalIOF.Header>
        <ModalIOF.Title>{i18n.t('app.atention')}</ModalIOF.Title>
      </ModalIOF.Header>
      <ModalIOF.Body>
        <p style={{ textAlign: 'center', fontWeight: 500 }}>
          La extracción solicitada es mayor a la cantidad de producto almacenado, ¿Desea continuar con la
          operación?
        </p>
      </ModalIOF.Body>
      <ModalIOF.Helper>
        <ModalIOF.Button
          close
          variant="contained"
          size="medium"
          sx={configButtonStylesContained}
          onClick={() => {}}
        >
          {i18n.t('app.cancel')}
        </ModalIOF.Button>
        <Button variant="contained" size="medium" sx={configButtonStylesContained} onClick={handleSave}>
          {i18n.t('app.continue')}
        </Button>
      </ModalIOF.Helper>
    </ModalIOF>
  );
};
